(function () {
  "use strict";

  var e = {
    d: function d(t, r) {
      for (var n in r) {
        e.o(r, n) && !e.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: r[n]
        });
      }
    },
    o: function o(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    },
    r: function r(e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }
  },
      t = {};
  e.r(t), e.d(t, {
    default: function _default() {
      return i;
    }
  });

  var r = require("react");

  function n(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (null != r) {
        var n,
            o,
            i = [],
            a = !0,
            u = !1;

        try {
          for (r = r.call(e); !(a = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0) {
            ;
          }
        } catch (e) {
          u = !0, o = e;
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (u) throw o;
          }
        }

        return i;
      }
    }(e, t) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return o(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(e, t) : void 0;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function o(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var i = function i() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 300,
        t = arguments.length > 1 ? arguments[1] : void 0,
        o = (0, r.useState)(t),
        i = n(o, 2),
        a = i[0],
        u = i[1];
    return (0, r.useEffect)(function () {
      var t = function t() {
        var t = window.screen.height - e > window.visualViewport.height;
        a != t && u(t);
      };

      return window.visualViewport.addEventListener("resize", t), function () {
        window.visualViewport.removeEventListener("resize", t);
      };
    }, []), a;
  };

  module.exports = t;
})();